import React from 'react';
import { Copyright } from 'lucide-react';
import ServiceTemplate from './ServiceTemplate';

const IPPage = () => {
  const serviceData = {
    icon: Copyright,
    nameAr: 'دائرة الملكية الفكرية',
    nameEn: 'Intellectual Property Department',
    taglineAr: 'حماية شاملة لحقوق الملكية الفكرية',
    taglineEn: 'Comprehensive protection of intellectual property rights',
    
    descriptionAr: [
      'دائرة الملكية الفكرية في وازن متخصصة في حماية جميع أنواع حقوق الملكية الفكرية بما في ذلك العلامات التجارية، براءات الاختراع، حقوق التأليف، والأسرار التجارية. نقدم خدمات شاملة من التسجيل وحتى الدفاع عن الحقوق.',
      'نعمل مع الهيئة السعودية للملكية الفكرية ولدينا خبرة واسعة في رصد ومكافحة الاعتداءات على حقوق الملكية الفكرية، مع إمكانية التسجيل الدولي للعلامات.'
    ],
    descriptionEn: [
      'Wazin\'s Intellectual Property Department specializes in protecting all types of intellectual property rights including trademarks, patents, copyrights, and trade secrets. We provide comprehensive services from registration to defending rights.',
      'We work with the Saudi Authority for Intellectual Property and have extensive experience in monitoring and combating infringements on intellectual property rights, with the possibility of international trademark registration.'
    ],

    services: [
      {
        nameAr: 'تسجيل العلامات التجارية محلياً ودولياً حسب الإمكان',
        nameEn: 'Registering trademarks locally and internationally as possible',
        descAr: 'تسجيل وحماية العلامات التجارية في المملكة العربية السعودية ودولياً عبر الاتفاقيات الدولية',
        descEn: 'Registering and protecting trademarks in Saudi Arabia and internationally through international treaties'
      },
      {
        nameAr: 'تسجيل حقوق الملكية الفكرية وحقوق المؤلف',
        nameEn: 'Registering intellectual property and copyright',
        descAr: 'تسجيل وحماية جميع أنواع حقوق الملكية الفكرية والتأليف والنشر',
        descEn: 'Registering and protecting all types of intellectual property and copyright'
      },
      {
        nameAr: 'متابعة طلبات تسجيل العلامات والتجاوب مع ملاحظات الجهات المختصة',
        nameEn: 'Following up trademark registration applications and responding to authorities remarks',
        descAr: 'متابعة يومية لطلبات التسجيل والرد على ملاحظات الهيئة السعودية للملكية الفكرية',
        descEn: 'Daily follow-up of registration applications and responding to Saudi Authority for Intellectual Property remarks'
      },
      {
        nameAr: 'إدارة الاعتراضات على تسجيل العلامات أو رفضها',
        nameEn: 'Managing objections to trademark registration or rejection',
        descAr: 'التعامل مع الاعتراضات على طلبات التسجيل والرد عليها أو الاعتراض على علامات الغير',
        descEn: 'Handling objections to registration applications and responding or objecting to others trademarks'
      },
      {
        nameAr: 'إدارة النزاعات المتعلقة بالتعدي على العلامات التجارية وحقوق الملكية',
        nameEn: 'Managing disputes related to trademark infringement and IP rights',
        descAr: 'معالجة قضايا التعدي على العلامات التجارية والحقوق الفكرية واتخاذ الإجراءات القانونية',
        descEn: 'Handling trademark and intellectual property infringement cases and taking legal actions'
      },
      {
        nameAr: 'حماية الأسرار التجارية والبرمجيات والمحتوى الرقمي',
        nameEn: 'Protecting trade secrets, software, and digital content',
        descAr: 'حماية الأسرار التجارية للشركات والبرمجيات والمحتوى الرقمي من التعدي',
        descEn: 'Protecting company trade secrets, software, and digital content from infringement'
      },
      {
        nameAr: 'إعداد وصياغة عقود وترخيص استخدام العلامات والحقوق الفكرية',
        nameEn: 'Preparing trademark and IP licensing contracts',
        descAr: 'صياغة عقود الترخيص باستخدام العلامات التجارية والحقوق الفكرية للغير',
        descEn: 'Drafting licensing contracts for using trademarks and intellectual property rights'
      }
    ],

    specializations: [
      { ar: 'العلامات التجارية', en: 'Trademarks' },
      { ar: 'حقوق التأليف والنشر', en: 'Copyrights and Publishing' },
      { ar: 'براءات الاختراع', en: 'Patents' },
      { ar: 'الأسرار التجارية', en: 'Trade Secrets' },
      { ar: 'التصاميم الصناعية', en: 'Industrial Designs' },
      { ar: 'المحتوى الرقمي', en: 'Digital Content' },
      { ar: 'العلامات المميزة', en: 'Distinctive Marks' },
      { ar: 'حقوق البرمجيات', en: 'Software Rights' },
      { ar: 'التسميات الفنية', en: 'Artistic Designs' },
      { ar: 'المؤشرات الجغرافية', en: 'Geographical Indications' }
    ],

    faqs: [
      {
        questionAr: 'كيف أسجل علامتي التجارية؟',
        questionEn: 'How do I register my trademark?',
        answerAr: 'نقوم بدراسة العلامة وفحص مدى إمكانية تسجيلها، ثم تقديم طلب التسجيل لدى الهيئة السعودية للملكية الفكرية مع متابعة جميع الإجراءات حتى الحصول على شهادة التسجيل.',
        answerEn: 'We study the trademark and examine the possibility of registering it, then submit the registration application to the Saudi Authority for Intellectual Property with follow-up on all procedures until obtaining the registration certificate.'
      },
      {
        questionAr: 'كم تستغرق مدة حماية العلامة التجارية؟',
        questionEn: 'How long does trademark protection last?',
        answerAr: 'حماية العلامة التجارية تستمر لمدة 10 سنوات قابلة للتجديد لفترات مماثلة. نقوم بمتابعة تجديد العلامات لعملائنا بشكل دوري.',
        answerEn: 'Trademark protection lasts for 10 years renewable for similar periods. We follow up on trademark renewals for our clients periodically.'
      },
      {
        questionAr: 'ماذا أفعل إذا اعتدى أحد على علامتي؟',
        questionEn: 'What should I do if someone infringes on my trademark?',
        answerAr: 'يجب التواصل معنا فوراً لتوثيق الاعتداء ورفع دعوى قضائية أو تقديم شكوى لدى الهيئة السعودية للملكية الفكرية. نعمل على إيقاف الاعتداء والحصول على التعويض المناسب.',
        answerEn: 'You should contact us immediately to document the infringement and file a lawsuit or submit a complaint to the Saudi Authority for Intellectual Property. We work to stop the infringement and obtain appropriate compensation.'
      },
      {
        questionAr: 'هل يمكن تسجيل علامتي دولياً؟',
        questionEn: 'Can I register my trademark internationally?',
        answerAr: 'نعم، نقدم خدمات التسجيل الدولي للعلامات عبر نظام مدريد (Madrid Protocol) الذي يسمح بتسجيل العلامة في أكثر من 100 دولة بطلب واحد.',
        answerEn: 'Yes, we provide international trademark registration services through the Madrid Protocol system, which allows trademark registration in more than 100 countries with a single application.'
      }
    ]
  };

  return <ServiceTemplate serviceData={serviceData} />;
};

export default IPPage;